<!-- eslint-disable max-len -->
<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" height="20" viewBox="0 0 20 20" width="20">
    <g :fill="pathFill">
      <path
        d="m10 14c-.27614 0-.5-.2239-.5-.5v-5.7929l-1.64645 1.64645c-.19526.19527-.51184.19527-.7071 0-.19527-.19526-.19527-.51184 0-.7071l2.5-2.5c.19526-.19527.51185-.19527.70715 0l2.5 2.5c.1952.19526.1952.51184 0 .7071-.1953.19527-.5119.19527-.7072 0l-1.6464-1.64644v5.79289c0 .2761-.2239.5-.5.5z"
      />
      <path
        d="m2 6c0-1.10457.89543-2 2-2h12c1.1046 0 2 .89543 2 2v8c0 1.1046-.8954 2-2 2h-12c-1.10457 0-2-.8954-2-2zm2-1c-.55228 0-1 .44772-1 1v8c0 .5523.44772 1 1 1h12c.5523 0 1-.4477 1-1v-8c0-.55228-.4477-1-1-1z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    pathFill: {
      type: String,
      default: '#FFFFFF',
    },
  },
};
</script>
